angular.module('app').config(packagesRouting);

function packagesRouting($routeProvider) {
  $routeProvider
    .when('/packages', {
      pageTitle: 'PACKAGES',
      template: '<packages-page></packages-page>',
      menu: 'products',
      accessPermission: 'index_package_accountadmin',
      authReq: true,
    })
    .when('/packages/new', {
      pageTitle: 'ADD_PACKAGE',
      template: '<package-page></package-page>',
      breadcrumb: {
        label: 'PACKAGES',
        parent: 'packages',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'create_package_accountadmin',
      authReq: true,
    })
    .when('/packages/:id', {
      pageTitle: 'PACKAGE_OVERVIEW',
      template: '<package-page></package-page>',
      breadcrumb: {
        label: 'PACKAGES',
        parent: 'packages',
        ajs: true,
      },
      menu: 'products',
      accessPermission: 'show_package_accountadmin',
      authReq: true,
    });
}

packagesRouting.$inject = ['$routeProvider'];
